import React from 'react';
import classNames from 'classnames/bind';
import styles from './DayPlaceholder.module.scss';

const cx = classNames.bind(styles);

const DayPlaceholder = ({ units }: { units: string }) => (
  <div
    className={cx(styles.graphDayPlaceholder, {
      [styles.metricUnits]: units === 'M',
    })}
    data-testid="day-selector-graph-day-placeholder"
  />
);

export default DayPlaceholder;
